import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import FloatingLabelInput from "./FloatingLabelInput"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import { Multiselect } from "multiselect-react-dropdown"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"
import Select from "react-select"
import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

import Switch from "@material-ui/core/Switch"
import Collapse from "@material-ui/core/Collapse"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import ReactExport from "react-data-export"
import Avatar from "@material-ui/core/Avatar"
import { Lightbox } from "react-modal-image"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}
const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      select: {
            searchBox: {
                  // To change search box element look
                  border: "none",
                  fontSize: "35px",
                  minheight: "50px",
            },
            inputField: {
                  // To change input field position or margin
                  margin: "5px",
            },
            chips: {
                  // To change css chips(Selected options)
                  background: "red",
            },
            optionContainer: {
                  // To change css for option container
                  border: "2px solid",
            },
            option: {
                  // To change css for dropdown options
                  color: "blue",
            },
      },
})

class ChangeRequestFinancialApprovalNot extends Component {
      cookies = new Cookies()

      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  requestinfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  showPaperDetail: false,
                  archiveDetail: [],
                  orderBy: "request_id",
                  order: "desc",
                  options: [],
                  optionFieldInsurance: [],
                  optionCompany: [],
                  optionCity: [],
                  optionState: [],
                  selectedFieldInsurance: [],
                  selectedCompany: [],
                  selectedCity: [],
                  selectedState: [],
                  selectedDayEnd: "",
                  selectedDayStart: "",
                  dataChart: [],
                  mobileAgentFilter: "",
                  mobileUsertFilter: "",
                  requestIdFilter: "",
                  urlToLargeImageFile: "",
                  urlToHugeImageFile: "",
                  descImageFile: "",
                  openImageBox: false,
                  insurancePrice: "",
                  insuranceDifferencePrice: "",

                  resource: "",
            }
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getOrder()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getOrder() {
            const { rowsPerPage, page } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              console.log("arr : ", arr)
                              self.setState({ requestinfos: arr.data, requestinfofilter: arr.data, arrCount: arr.cnt }, () => {
                                    self.getFieldInsurance()
                                    self.getCompany()
                                    self.getState()
                                    self.hidePaperDetail()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_request")
            fd.append("approvalmode", "notapprov")
            fd.append("limit", rowsPerPage)
            fd.append("offset", page * rowsPerPage)

            xhttp.open("POST", `${constants.BASE_URL}/financialapproval`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getFieldInsurance() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var i,
                                    temp,
                                    temparray = []

                              self.setState({ optionFieldInsurance: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldinsurance")
            xhttp.open("POST", `${constants.BASE_URL}/financialapproval`)
            xhttp.send(fd)
      }

      getCompany() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ optionCompany: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_company")
            xhttp.open("POST", `${constants.BASE_URL}/company`)
            xhttp.send(fd)
      }

      getState() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState(
                                    {
                                          optionState: arr.data,
                                    },
                                    () => {}
                              )
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_state")
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      getOptionFilterCity = () => {
            const { selectedState, optionState } = this.state
            this.setState({ optionCity: [] }, () => {
                  for (var i = 0; i < selectedState.length; i++) {
                        this.getCity(selectedState[i].state_id)
                  }
            })
      }
      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            })
      }
      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      handleChangeResorce = (event) => {
            this.setState({ resource: event.target.value })
      }
      handleInsurancePrice = (event) => {
            this.setState({ insurancePrice: event.target.value })
      }
      handleInsuranceDifferencePrice = (event) => {
            this.setState({ insuranceDifferencePrice: event.target.value })
      }
      getCity = (state_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State
                              if (self.state.optionCity.length > 0) {
                                    var State = self.state.optionCity
                              } else {
                                    var State = []
                              }
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push(arr.data[k])
                              }
                              self.setState({ optionCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", state_id)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      changeFinancialApprove = (request_id) => {
            const { archiveDetail, resource, insurancePrice, insuranceDifferencePrice } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success", showPaperDetail: false }, () => {
                                    self.getOrder()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "okfinancialapproval")
            fd.append("request_id", request_id)
            fd.append("request_financial_approval_desc", resource)
            fd.append("request_financial_approval_price", insurancePrice)
            fd.append("request_financial_approval_difference_price", insuranceDifferencePrice)
            xhttp.open("POST", `${constants.BASE_URL}/financialapproval`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeFinancialNotApprove = (request_id) => {
            const { archiveDetail, resource, insurancePrice, insuranceDifferencePrice } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success", showPaperDetail: false }, () => {
                                    self.getOrder()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "notfinancialapproval")
            fd.append("request_id", request_id)
            fd.append("request_financial_approval_desc", resource)
            fd.append("request_financial_approval_price", insurancePrice)
            fd.append("request_financial_approval_difference_price", insuranceDifferencePrice)

            xhttp.open("POST", `${constants.BASE_URL}/financialapproval`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.requestinfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }
      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
                  this.getOrder()
            })
      }

      handleSelectRows = (request_id, row) => {
            var request_ready = null
            var request_financial_approval = null
            if (row["request_ready"]) {
                  request_ready = row["request_ready"][0]
            }
            if (row["request_financial_approval"]) {
                  request_financial_approval = row["request_financial_approval"][0]
            }
            this.setState({
                  showPaperDetail: true,
                  archiveDetail: row,
                  insurancePrice: request_financial_approval["request_financial_approval_price"],
                  insuranceDifferencePrice: request_financial_approval["request_financial_approval_difference_price"],
                  resource: request_financial_approval["request_financial_approval_desc"],
            })
      }

      hidePaperDetail = (event) => {
            this.setState({ showPaperDetail: false })
      }

      onSelectOptionFieldInsurance = (selectedList, selectedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedFieldInsurance: selectedList }, () => {
                  this.filterList()
            })
      }

      onRemoveOptionFieldInsurance = (selectedList, removedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedFieldInsurance: selectedList }, () => {
                  this.filterList()
            })
      }

      onSelectOptionCompany = (selectedList, selectedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedCompany: selectedList }, () => {
                  this.filterList()
            })
      }

      onRemoveOptionCompany = (selectedList, removedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedCompany: selectedList }, () => {
                  this.filterList()
            })
      }

      onSelectOptionCity = (selectedList, selectedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedCity: selectedList }, () => {
                  this.filterList()
            })
      }

      onRemoveOptionCity = (selectedList, removedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedCity: selectedList }, () => {
                  this.filterList()
            })
      }

      onSelectOptionState = (selectedList, selectedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedState: selectedList }, () => {
                  this.getOptionFilterCity()
                  this.filterList()
            })
      }

      onRemoveOptionState = (selectedList, removedItem) => {
            this.setState({ requestinfofilter: this.state.requestinfos, selectedState: selectedList }, () => {
                  this.getOptionFilterCity()
                  this.filterList()
            })
      }

      handleChangeFilterMobileAgent = (event) => {
            this.setState({ mobileAgentFilter: event.target.value }, () => {
                  this.filterList()
            })
      }

      handleChangeFilterMobileUser = (event) => {
            this.setState({ mobileUsertFilter: event.target.value }, () => {
                  this.filterList()
            })
      }
      handleChangeFilterRequestId = (event) => {
            this.setState({ requestIdFilter: event.target.value }, () => {
                  this.filterList()
            })
      }

      filterList = () => {
            const {
                  requestinfos,
                  mobileAgentFilter,
                  mobileUsertFilter,
                  requestIdFilter,
                  selectedFieldInsurance,
                  selectedCompany,
                  selectedCity,
                  selectedState,
                  selectedDayEnd,
                  selectedDayStart,
            } = this.state
            var timeStampStart = parseInt(
                  Moment(JDate.toGregorian(selectedDayStart.year, selectedDayStart.month, selectedDayStart.day)).format("x"),
                  0
            )
            var timeStampEnd = parseInt(Moment(JDate.toGregorian(selectedDayEnd.year, selectedDayEnd.month, selectedDayEnd.day)).format("x"), 0)

            var i, temparray, temparray2, requst_ready_start_date
            temparray = requestinfos
            temparray2 = []
            for (i = 0; i < temparray.length; i++) {
                  var request = temparray[i]
                  var request_ready = request["request_ready"][0]
                  requst_ready_start_date = parseInt(Moment(request_ready.requst_ready_start_date, "YYYY-M-D HH:mm:ss").format("x"))
                  if (
                        this.feieldInsuranceExist(temparray[i].fieldinsurance_id, selectedFieldInsurance) &&
                        this.companyExist(temparray[i].request_company_id, selectedCompany) &&
                        this.cityExist(temparray[i].agent_city_id, selectedCity) &&
                        this.stateExist(temparray[i].agent_state_id, selectedState) &&
                        ((mobileAgentFilter !== "" && temparray[i].agent_mobile.includes(mobileAgentFilter)) || mobileAgentFilter === "") &&
                        ((mobileUsertFilter !== "" && temparray[i].user_mobile.includes(mobileUsertFilter)) || mobileUsertFilter === "") &&
                        ((requestIdFilter !== "" && temparray[i].request_id === requestIdFilter) || requestIdFilter === "") &&
                        (requst_ready_start_date > timeStampStart || !timeStampStart) &&
                        (requst_ready_start_date < timeStampEnd || !timeStampEnd)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ requestinfofilter: temparray2 }, () => {})
      }

      feieldInsuranceExist = (fieldinsurance_id, selectedFieldInsurance) => {
            if (selectedFieldInsurance.length === 0) {
                  return true
            } else {
                  for (var j = 0; j < selectedFieldInsurance.length; j++) {
                        if (fieldinsurance_id === selectedFieldInsurance[j].fieldinsurance_id) {
                              return true
                        }
                  }
                  return false
            }
      }

      companyExist = (request_company_id, selectedCompany) => {
            if (selectedCompany.length === 0) {
                  return true
            } else {
                  for (var j = 0; j < selectedCompany.length; j++) {
                        if (request_company_id === selectedCompany[j].company_id) {
                              return true
                        }
                  }
                  return false
            }
      }

      cityExist = (agent_city_id, selectedCity) => {
            if (selectedCity.length === 0) {
                  return true
            } else {
                  for (var j = 0; j < selectedCity.length; j++) {
                        if (agent_city_id === selectedCity[j].city_id) {
                              return true
                        }
                  }
                  return false
            }
      }

      stateExist = (agent_state_id, selectedState) => {
            if (selectedState.length === 0) {
                  return true
            } else {
                  for (var j = 0; j < selectedState.length; j++) {
                        if (agent_state_id === selectedState[j].state_id) {
                              return true
                        }
                  }
                  return false
            }
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) }, () => {
                  this.getOrder()
            })
      }

      clearDeyEnd = (event) => {
            this.setState({ selectedDayEnd: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedDayEnd = (event) => {
            this.setState({ selectedDayEnd: event }, () => {
                  this.filterList()
            })
      }

      clearDeyStart = (event) => {
            this.setState({ selectedDayStart: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedDayStart = (event) => {
            this.setState({ selectedDayStart: event }, () => {
                  this.filterList()
            })
      }

      renderCustomInputEnd = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ پایان"
                  value={
                        this.state.selectedDayEnd.year
                              ? this.state.selectedDayEnd.year + "/" + this.state.selectedDayEnd.month + "/" + this.state.selectedDayEnd.day
                              : ""
                  }
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyEnd}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputStart = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ شروع"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.selectedDayStart.year
                              ? this.state.selectedDayStart.year + "/" + this.state.selectedDayStart.month + "/" + this.state.selectedDayStart.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyStart}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      render() {
            const { classes } = this.props
            const {
                  insurancePrice,
                  insuranceDifferencePrice,
                  resource,
                  selectedDayEnd,
                  mobileAgentFilter,
                  mobileUsertFilter,
                  requestIdFilter,
                  selectedDayStart,
                  order,
                  orderBy,
                  archiveDetail,
                  showPaperDetail,
                  okstatus,
                  errstr,
                  redirect,
                  requestinfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
                  urlToHugeImageFile,
                  descImageFile,
                  urlToLargeImageFile,
            } = this.state
            var request_ready_image_tb = null
            var request_ready_file_tb = null
            var request_ready = null
            var user_pey_detail = null
            var user_pey_detail2 = null
            var request_financial_approval = null

            if (archiveDetail["request_financial_approval"]) {
                  request_financial_approval = archiveDetail["request_financial_approval"][0]
            }

            if (archiveDetail["request_ready"]) {
                  request_ready = archiveDetail["request_ready"][0]
                  if (request_ready) {
                        if (request_ready["request_ready_image_tb"]) {
                              request_ready_image_tb = request_ready["request_ready_image_tb"]
                        }
                        if (request_ready["request_ready_file_tb"]) {
                              request_ready_file_tb = request_ready["request_ready_file_tb"]
                        }
                  }
            }
            if (archiveDetail["user_pey_detail"]) {
                  user_pey_detail = archiveDetail["user_pey_detail"]
            }
            if (archiveDetail["user_pey_detail2"]) {
                  user_pey_detail2 = archiveDetail["user_pey_detail2"]
            }

            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper style={{ padding: "15px", direction: "rtl" }} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ شروع بزرگتر از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputStart} // render a custom input
                                                                                    value={selectedDayStart}
                                                                                    onChange={this.setSelectedDayStart}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ شروع کوچکتر از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputEnd} // render a custom input
                                                                                    value={selectedDayEnd}
                                                                                    onChange={this.setSelectedDayEnd}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={this.state.optionFieldInsurance} // Options to display in the dropdown
                                                                              selectedValues={this.state.selectedOptionFieldInsurance} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionFieldInsurance} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionFieldInsurance} // Function will trigger on remove event
                                                                              displayValue="fieldinsurance_fa" // Property name to display in the dropdown options
                                                                              placeholder="انتخاب رشته"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={this.state.optionCompany} // Options to display in the dropdown
                                                                              selectedValues={this.state.selectedOptionCompany} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionCompany} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionCompany} // Function will trigger on remove event
                                                                              displayValue="company_name" // Property name to display in the dropdown options
                                                                              placeholder="انتخاب شرکت"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={this.state.optionState} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionState} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionState} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionState} // Function will trigger on remove event
                                                                              ref={this.multiselectStateRef}
                                                                              displayValue="state_name" // Property name to display in the dropdown options
                                                                              placeholder="استان ها "
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={this.state.optionCity} // Options to display in the dropdown
                                                                              selectedValues={this.state.selectedOptionCity} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionCity} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionCity} // Function will trigger on remove event
                                                                              displayValue="city_name" // Property name to display in the dropdown options
                                                                              placeholder="انتخاب شهر"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} sm={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="همراه نماینده"
                                                                        value={mobileAgentFilter}
                                                                        handleInputt={this.handleChangeFilterMobileAgent}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12} sm={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="همراه کاربر"
                                                                        value={mobileUsertFilter}
                                                                        handleInputt={this.handleChangeFilterMobileUser}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12} sm={2}>
                                                                  <FloatingLabelInput
                                                                        placeholder="شماره سفارش"
                                                                        value={requestIdFilter}
                                                                        handleInputt={this.handleChangeFilterRequestId}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={2}></Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}></Grid>

                                    <Grid item xs={12}>
                                          <Collapse in={showPaperDetail}>
                                                <Container component="main" maxWidth="lg">
                                                      <Paper elevation={4} className={classes.root}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={4}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"شماره درخواست: " + archiveDetail["request_id"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={8} sm={4}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"رشته بیمه : " + archiveDetail["request_fieldinsurance_fa"]}
                                                                                    <img
                                                                                          alt=""
                                                                                          style={{ height: "30px", width: "atuo" }}
                                                                                          src={archiveDetail["fieldinsurance_logo_url"]}
                                                                                    />
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={12} sm={4}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"شرکت  : " + archiveDetail["company_name"]}
                                                                                    <img
                                                                                          alt=""
                                                                                          style={{ height: "30px", width: "atuo" }}
                                                                                          src={archiveDetail["company_logo_url"]}
                                                                                    />
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <Grid container spacing={3}>
                                                                              <Grid item xs={12} sm={6}>
                                                                                    {request_ready_image_tb ? (
                                                                                          <TableContainer component={Paper}>
                                                                                                <Table
                                                                                                      className={classes.table}
                                                                                                      aria-label="simple table"
                                                                                                >
                                                                                                      <TableHead>
                                                                                                            <TableRow>
                                                                                                                  <TableCell
                                                                                                                        style={{ minWidth: 60 }}
                                                                                                                        align="center"
                                                                                                                  >
                                                                                                                        نام عکس
                                                                                                                  </TableCell>
                                                                                                                  <TableCell
                                                                                                                        style={{ minWidth: 100 }}
                                                                                                                        align="center"
                                                                                                                  >
                                                                                                                        توضیحات
                                                                                                                  </TableCell>
                                                                                                                  <TableCell
                                                                                                                        style={{ minWidth: 30 }}
                                                                                                                        align="center"
                                                                                                                  >
                                                                                                                        عکس{" "}
                                                                                                                  </TableCell>
                                                                                                            </TableRow>
                                                                                                      </TableHead>
                                                                                                      <TableBody>
                                                                                                            {request_ready_image_tb.map((row) => {
                                                                                                                  return (
                                                                                                                        <TableRow
                                                                                                                              key={row.image_name}
                                                                                                                        >
                                                                                                                              <TableCell align="center">
                                                                                                                                    {" "}
                                                                                                                                    {row.image_name}
                                                                                                                              </TableCell>
                                                                                                                              <TableCell align="center">
                                                                                                                                    {row.image_desc}
                                                                                                                              </TableCell>

                                                                                                                              <TableCell align="center">
                                                                                                                                    <div
                                                                                                                                          style={{
                                                                                                                                                width:
                                                                                                                                                      "100%",
                                                                                                                                                textAlign:
                                                                                                                                                      "center",
                                                                                                                                          }}
                                                                                                                                    >
                                                                                                                                          <Avatar
                                                                                                                                                variant="rounded"
                                                                                                                                                alt="Remy Sharp"
                                                                                                                                                src={
                                                                                                                                                      row.image_tumb_url
                                                                                                                                                }
                                                                                                                                                onClick={() => {
                                                                                                                                                      this.setImageModel(
                                                                                                                                                            row.image_tumb_url,
                                                                                                                                                            row.image_url,
                                                                                                                                                            row.image_name
                                                                                                                                                      )
                                                                                                                                                }}
                                                                                                                                          />
                                                                                                                                    </div>
                                                                                                                              </TableCell>
                                                                                                                        </TableRow>
                                                                                                                  )
                                                                                                            })}
                                                                                                      </TableBody>
                                                                                                </Table>
                                                                                          </TableContainer>
                                                                                    ) : null}
                                                                              </Grid>
                                                                              <Grid item xs={12} sm={6}>
                                                                                    {request_ready_file_tb ? (
                                                                                          <TableContainer component={Paper}>
                                                                                                <Table
                                                                                                      className={classes.table}
                                                                                                      aria-label="simple table"
                                                                                                >
                                                                                                      <TableHead>
                                                                                                            <TableRow>
                                                                                                                  <TableCell
                                                                                                                        style={{ minWidth: 100 }}
                                                                                                                        align="center"
                                                                                                                  >
                                                                                                                        توضیحات
                                                                                                                  </TableCell>
                                                                                                                  <TableCell
                                                                                                                        style={{ minWidth: 30 }}
                                                                                                                        align="center"
                                                                                                                  >
                                                                                                                        لینک دانلود{" "}
                                                                                                                  </TableCell>
                                                                                                            </TableRow>
                                                                                                      </TableHead>
                                                                                                      <TableBody>
                                                                                                            {request_ready_file_tb.map((row) => {
                                                                                                                  return (
                                                                                                                        <TableRow
                                                                                                                              key={
                                                                                                                                    row.request_file_desc
                                                                                                                              }
                                                                                                                        >
                                                                                                                              <TableCell align="center">
                                                                                                                                    {" "}
                                                                                                                                    {
                                                                                                                                          row.request_file_desc
                                                                                                                                    }
                                                                                                                              </TableCell>

                                                                                                                              <TableCell align="center">
                                                                                                                                    <a
                                                                                                                                          href={
                                                                                                                                                row.request_file_url
                                                                                                                                          }
                                                                                                                                    >
                                                                                                                                          دانلود
                                                                                                                                    </a>
                                                                                                                              </TableCell>
                                                                                                                        </TableRow>
                                                                                                                  )
                                                                                                            })}
                                                                                                      </TableBody>
                                                                                                </Table>
                                                                                          </TableContainer>
                                                                                    ) : null}
                                                                              </Grid>
                                                                        </Grid>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"مشخصات کاربر: " +
                                                                                          archiveDetail["user_name"] +
                                                                                          " " +
                                                                                          archiveDetail["user_family"] +
                                                                                          " -  شماره همراه : " +
                                                                                          archiveDetail["user_mobile"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"مشخصات نماینده: " +
                                                                                          archiveDetail["agent_name"] +
                                                                                          " " +
                                                                                          archiveDetail["agent_family"] +
                                                                                          " -  شماره همراه : " +
                                                                                          archiveDetail["agent_mobile"] +
                                                                                          " - کد : " +
                                                                                          archiveDetail["agent_code"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Typography align="center" variant="h7">
                                                                                    {"استان : " +
                                                                                          archiveDetail["agent_state_name"] +
                                                                                          "   - شهرستان:  " +
                                                                                          archiveDetail["agent_city_name"]}
                                                                              </Typography>
                                                                        </div>
                                                                  </Grid>

                                                                  {request_ready ? (
                                                                        <Grid item xs={12}>
                                                                              <Grid container spacing={3}>
                                                                                    <Grid item xs={3}>
                                                                                          <Typography align="center" variant="h7">
                                                                                                {"شماره بیمه نامه:" +
                                                                                                      request_ready["requst_ready_num_ins"]}
                                                                                          </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={3}>
                                                                                          <Typography align="center" variant="h7">
                                                                                                {"قیمت اعلام شده نماینده:"}
                                                                                                <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={request_ready["requst_ready_end_price"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                />
                                                                                          </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={3}>
                                                                                          <Typography variant="h7">
                                                                                                {"تاریخ شروع : "}
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        request_ready[
                                                                                                                              "requst_ready_start_date"
                                                                                                                        ],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD ")}
                                                                                          </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={3}>
                                                                                          <Typography variant="h7">
                                                                                                {"تاریخ پایان: "}
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        request_ready[
                                                                                                                              "requst_ready_end_date"
                                                                                                                        ],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD ")}
                                                                                          </Typography>
                                                                                    </Grid>
                                                                              </Grid>
                                                                        </Grid>
                                                                  ) : null}
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <Typography align="center" variant="h6">
                                                                              {archiveDetail["user_pey_amount"] === null ||
                                                                              archiveDetail["user_pey_amount"] === ""
                                                                                    ? "مبلغ پرداخت شده : 0 ریال"
                                                                                    : "مبلغ پرداخت شده :  "}
                                                                              {archiveDetail["user_pey_amount"] === null ||
                                                                              archiveDetail["user_pey_amount"] === "" ? null : (
                                                                                    <NumberFormat
                                                                                          displayType={"text"}
                                                                                          value={archiveDetail["user_pey_amount"]}
                                                                                          thousandSeparator={true}
                                                                                          prefix={" ریال"}
                                                                                    />
                                                                              )}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <Typography align="center" variant="h6">
                                                                              {archiveDetail["user_pey_cash"] === null ||
                                                                              archiveDetail["user_pey_cash"] === ""
                                                                                    ? "مبلغ نقدی پرداخت شده : 0 ریال"
                                                                                    : "مبلغ نقدی پرداخت شده :  "}
                                                                              {archiveDetail["user_pey_cash"] === null ||
                                                                              archiveDetail["user_pey_cash"] === "" ? null : (
                                                                                    <NumberFormat
                                                                                          displayType={"text"}
                                                                                          value={archiveDetail["user_pey_cash"]}
                                                                                          thousandSeparator={true}
                                                                                          prefix={" ریال"}
                                                                                    />
                                                                              )}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <Typography align="center" variant="h6">
                                                                              {archiveDetail["user_pey_instalment"] === null ||
                                                                              archiveDetail["user_pey_instalment"] === ""
                                                                                    ? "مبلغ اقساط پرداخت شده : 0 ریال"
                                                                                    : "مبلغ اقساط پرداخت شده :  "}
                                                                              {archiveDetail["user_pey_instalment"] === null ||
                                                                              archiveDetail["user_pey_instalment"] === "" ? null : (
                                                                                    <NumberFormat
                                                                                          displayType={"text"}
                                                                                          value={archiveDetail["user_pey_instalment"]}
                                                                                          thousandSeparator={true}
                                                                                          prefix={" ریال"}
                                                                                    />
                                                                              )}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        {user_pey_detail2 ? (
                                                                              <TableContainer component={Paper}>
                                                                                    <Table className={classes.table} aria-label="simple table">
                                                                                          <TableHead>
                                                                                                <TableRow>
                                                                                                      <TableCell align="center">
                                                                                                            {" "}
                                                                                                            مبلغ پرداخت شده
                                                                                                      </TableCell>
                                                                                                      <TableCell align="center">توضیحات</TableCell>
                                                                                                </TableRow>
                                                                                          </TableHead>
                                                                                          <TableBody>
                                                                                                {user_pey_detail2.map((row) => (
                                                                                                      <TableRow key={row.user_pey_amount}>
                                                                                                            <TableCell align="center">
                                                                                                                  <NumberFormat
                                                                                                                        displayType={"text"}
                                                                                                                        value={row.user_pey_amount}
                                                                                                                        thousandSeparator={true}
                                                                                                                        prefix={" ریال"}
                                                                                                                  />
                                                                                                            </TableCell>
                                                                                                            <TableCell align="center">
                                                                                                                  {row.user_pey_desc}
                                                                                                            </TableCell>
                                                                                                      </TableRow>
                                                                                                ))}
                                                                                          </TableBody>
                                                                                    </Table>
                                                                              </TableContainer>
                                                                        ) : null}
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        {user_pey_detail ? (
                                                                              <TableContainer component={Paper}>
                                                                                    <Table className={classes.table} aria-label="simple table">
                                                                                          <TableHead>
                                                                                                <TableRow>
                                                                                                      <TableCell align="center">
                                                                                                            {" "}
                                                                                                            مبلغ پرداخت شده
                                                                                                      </TableCell>
                                                                                                      <TableCell align="center">توضیحات</TableCell>
                                                                                                      <TableCell align="center">تصویر </TableCell>
                                                                                                      <TableCell align="center">تاریخ</TableCell>
                                                                                                      <TableCell align="center">شماره چک</TableCell>
                                                                                                </TableRow>
                                                                                          </TableHead>
                                                                                          <TableBody>
                                                                                                {user_pey_detail.map((row) => {
                                                                                                      return (
                                                                                                            <TableRow key={row.user_pey_amount}>
                                                                                                                  <TableCell align="center">
                                                                                                                        <NumberFormat
                                                                                                                              displayType={"text"}
                                                                                                                              value={
                                                                                                                                    row.user_pey_amount
                                                                                                                              }
                                                                                                                              thousandSeparator={true}
                                                                                                                              prefix={" ریال"}
                                                                                                                        />
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        {row.user_pey_desc}
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        <Avatar
                                                                                                                              variant="rounded"
                                                                                                                              alt="Remy Sharp"
                                                                                                                              src={
                                                                                                                                    row.user_pey_image_turl
                                                                                                                              }
                                                                                                                              onClick={() => {
                                                                                                                                    this.setImageModel(
                                                                                                                                          row.user_pey_image_turl,
                                                                                                                                          row.user_pey_image_url,
                                                                                                                                          "عکس چک های سفارش "
                                                                                                                                    )
                                                                                                                              }}
                                                                                                                        />
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        {row.instalment_check_date}{" "}
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        {row.instalment_check_num}
                                                                                                                  </TableCell>
                                                                                                            </TableRow>
                                                                                                      )
                                                                                                })}
                                                                                          </TableBody>
                                                                                    </Table>
                                                                              </TableContainer>
                                                                        ) : null}
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            </Grid>

                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Typography variant="h6">{"تایید مالی بیمه نامه"}</Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                              placeholder="قیمت تایید شده"
                                                                              value={insurancePrice}
                                                                              handleInputt={this.handleInsurancePrice}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                              placeholder="اختلاف قیمت"
                                                                              value={insuranceDifferencePrice}
                                                                              handleInputt={this.handleInsuranceDifferencePrice}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="توضیحات  "
                                                                              value={resource}
                                                                              handleInputt={this.handleChangeResorce}
                                                                        />
                                                                  </Grid>
                                                                  {request_financial_approval ? (
                                                                        <Grid item xs={12}>
                                                                              <Grid container spacing={3}>
                                                                                    <Grid item xs={4}>
                                                                                          <Typography align="center" variant="h7">
                                                                                                {"نام کارمند :" +
                                                                                                      request_financial_approval["employee_name"] +
                                                                                                      " " +
                                                                                                      request_financial_approval["employee_family"]}
                                                                                          </Typography>
                                                                                    </Grid>
                                                                                    <Grid item xs={4}>
                                                                                          <Typography variant="h7">
                                                                                                {"تاریخ بررسی: "}
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        request_financial_approval[
                                                                                                                              "request_financial_approval_date"
                                                                                                                        ],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD") +
                                                                                                      Moment(
                                                                                                            request_financial_approval[
                                                                                                                  "request_financial_approval_date"
                                                                                                            ],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                      ).format("HH:mm:ss")}
                                                                                          </Typography>
                                                                                    </Grid>
                                                                              </Grid>
                                                                        </Grid>
                                                                  ) : null}
                                                                  <Grid item xs={5}>
                                                                        <Button
                                                                              variant="contained"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.changeFinancialApprove(archiveDetail["request_id"])
                                                                              }}
                                                                        >
                                                                              تایید مالی بیمه نامه
                                                                        </Button>
                                                                  </Grid>

                                                                  <Grid item xs={5}>
                                                                        <Button
                                                                              variant="contained"
                                                                              color="secondary"
                                                                              onClick={(e) => {
                                                                                    this.changeFinancialNotApprove(archiveDetail["request_id"])
                                                                              }}
                                                                        >
                                                                              رد مالی بیمه نامه
                                                                        </Button>
                                                                  </Grid>

                                                                  <Grid item xs={2}>
                                                                        <div style={{ width: "100%", textAlign: "left" }}>
                                                                              <Button onClick={this.hidePaperDetail}>{"بستن"}</Button>
                                                                        </div>
                                                                  </Grid>
                                                            </Grid>
                                                      </Paper>
                                                </Container>
                                          </Collapse>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <ExcelFile
                                                            element={
                                                                  <Button variant="outlined" color="primary">
                                                                        {" "}
                                                                        {"اکسل "}
                                                                  </Button>
                                                            }
                                                      >
                                                            <ExcelSheet data={requestinfofilter} name="نمایندگان">
                                                                  <ExcelColumn label="آی دی سفارش" value="request_id" />
                                                                  <ExcelColumn label="شرکت" value="company_name" />
                                                                  <ExcelColumn label="رشته بیمه ای" value="request_fieldinsurance_fa" />
                                                                  <ExcelColumn label="توضیحات" value="request_description" />
                                                                  <ExcelColumn label="اخرین وضعیت" value="request_last_state_name" />
                                                                  <ExcelColumn label="مبلغ پرداخت شده" value="user_pey_amount" />
                                                                  <ExcelColumn label="مبلغ نقدی" value="user_pey_cash" />
                                                                  <ExcelColumn label="نام کاربر" value="user_name" />
                                                                  <ExcelColumn label="نام خانوادگی کاربر" value="user_family" />
                                                                  <ExcelColumn label="همراه کاربر " value="user_mobile" />
                                                                  <ExcelColumn label="آی دی" value="agent_id" />
                                                                  <ExcelColumn label="جنسیت" value="agent_gender" />
                                                                  <ExcelColumn label="نام" value="agent_name" />
                                                                  <ExcelColumn label="نام خانوادگی" value="agent_family" />
                                                                  <ExcelColumn label="شماره همراه" value="agent_mobile" />
                                                                  <ExcelColumn label="تلفن دفتر" value="agent_tell" />
                                                                  <ExcelColumn label="ایمیل" value="agent_email" />
                                                                  <ExcelColumn label="تلفن ضروری" value="agent_required_phone" />
                                                                  <ExcelColumn label="استان " value="agent_state_name" />
                                                                  <ExcelColumn label="شهر " value="agent_city_name" />
                                                                  <ExcelColumn label="نام محله" value="agent_sector_name" />
                                                                  <ExcelColumn label="آدرس" value="agent_address" />
                                                                  <ExcelColumn label="نام بانک" value="agent_bankname" />
                                                                  <ExcelColumn label="شماره حساب" value="agent_banknum" />
                                                                  <ExcelColumn label="شماره شبا" value="agent_banksheba" />
                                                                  <ExcelColumn label="شرکت بیمه" value="agent_company_name" />
                                                                  <ExcelColumn label="کد نمایندگی" value="agent_code" />
                                                            </ExcelSheet>
                                                      </ExcelFile>

                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"request_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 30 }}
                                                                                    sortDirection={orderBy === "request_id" ? order : false}
                                                                              >
                                                                                    {"شماره"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_id"}
                                                                                          direction={orderBy === "request_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_company_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_company_id"}
                                                                                          direction={orderBy === "request_company_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_company_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_fieldinsurance_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"رشته بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_fieldinsurance_fa"}
                                                                                          direction={
                                                                                                orderBy === "request_fieldinsurance_fa"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_state_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مشخصات نماینده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_code"}
                                                                                          direction={orderBy === "agent_code" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_code")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_city_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مبلغ نقدی پرداخت شده "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_pey_cash"}
                                                                                          direction={orderBy === "user_pey_cash" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_pey_cash")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مبلغ اقساط پرداخت شده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_pey_instalment"}
                                                                                          direction={
                                                                                                orderBy === "user_pey_instalment" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_pey_instalment")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" کل حق بیمه دریافتی"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_pey_amount"}
                                                                                          direction={orderBy === "user_pey_amount" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_pey_amount")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"user_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"قیمت اعلام شده نماینده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_mobile"}
                                                                                          direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"user_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"اختلاف قیمت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_mobile"}
                                                                                          direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"user_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تاریخ شروع"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_mobile"}
                                                                                          direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell>{""}</TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                                                                              if (row["request_ready"]) {
                                                                                    request_ready = row["request_ready"][0]
                                                                              }
                                                                              console.log(
                                                                                    request_ready["requst_ready_end_price"] - row["user_pey_amount"]
                                                                              )
                                                                              return (
                                                                                    <TableRow
                                                                                          hover
                                                                                          role="checkbox"
                                                                                          tabIndex={-1}
                                                                                          key={row["request_id"]}
                                                                                          value={row}
                                                                                          onClick={(e) => {
                                                                                                this.handleSelectRows(e, row)
                                                                                          }}
                                                                                    >
                                                                                          <TableCell key={"request_id"} align={"center"}>
                                                                                                {row["request_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"request_company_id"} align={"center"}>
                                                                                                <img
                                                                                                      alt=""
                                                                                                      style={{ height: "30px", width: "atuo" }}
                                                                                                      src={row["company_logo_url"]}
                                                                                                />

                                                                                                {row["company_name"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                                key={"request_fieldinsurance_fa"}
                                                                                                align={"center"}
                                                                                          >
                                                                                                <img
                                                                                                      alt=""
                                                                                                      style={{ height: "30px", width: "atuo" }}
                                                                                                      src={row["fieldinsurance_logo_url"]}
                                                                                                />

                                                                                                {row["request_fieldinsurance_fa"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"agent_state_name"} align={"center"}>
                                                                                                {row["agent_name"] +
                                                                                                      " " +
                                                                                                      row["agent_family"] +
                                                                                                      " - کد : " +
                                                                                                      row["agent_code"]}
                                                                                                <br />
                                                                                                {"شماره همراه : " + row["agent_mobile"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_pey_cash"} align={"center"}>
                                                                                                {
                                                                                                      <NumberFormat
                                                                                                            displayType={"text"}
                                                                                                            value={row["user_pey_cash"]}
                                                                                                            thousandSeparator={true}
                                                                                                            prefix={" ریال"}
                                                                                                      />
                                                                                                }
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_pey_instalment"} align={"center"}>
                                                                                                {
                                                                                                      <NumberFormat
                                                                                                            displayType={"text"}
                                                                                                            value={row["user_pey_instalment"]}
                                                                                                            thousandSeparator={true}
                                                                                                            prefix={" ریال"}
                                                                                                      />
                                                                                                }
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_pey_amount"} align={"center"}>
                                                                                                {
                                                                                                      <NumberFormat
                                                                                                            displayType={"text"}
                                                                                                            value={row["user_pey_amount"]}
                                                                                                            thousandSeparator={true}
                                                                                                            prefix={" ریال"}
                                                                                                      />
                                                                                                }
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_mobile"} align={"center"}>
                                                                                                {
                                                                                                      <NumberFormat
                                                                                                            displayType={"text"}
                                                                                                            value={
                                                                                                                  request_ready[
                                                                                                                        "requst_ready_end_price"
                                                                                                                  ]
                                                                                                            }
                                                                                                            thousandSeparator={true}
                                                                                                            prefix={" ریال"}
                                                                                                      />
                                                                                                }
                                                                                          </TableCell>

                                                                                          <TableCell key={"requst_ready_end_price"} align={"center"}>
                                                                                                {
                                                                                                      <NumberFormat
                                                                                                            displayType={"text"}
                                                                                                            value={
                                                                                                                  request_ready[
                                                                                                                        "requst_ready_end_price"
                                                                                                                  ] - row["user_pey_amount"]
                                                                                                            }
                                                                                                            thousandSeparator={true}
                                                                                                            prefix={" ریال"}
                                                                                                      />
                                                                                                }
                                                                                          </TableCell>

                                                                                          <TableCell key={"requst_ready_start_date"} align={"center"}>
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        request_ready[
                                                                                                                              "requst_ready_start_date"
                                                                                                                        ],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD ")}
                                                                                          </TableCell>

                                                                                          <TableCell key={""} align={"center"}>
                                                                                                {
                                                                                                      <Button
                                                                                                            variant="contained"
                                                                                                            color="primary"
                                                                                                            onClick={(e) => {
                                                                                                                  this.changeFinancialApprove(
                                                                                                                        row["request_id"]
                                                                                                                  )
                                                                                                            }}
                                                                                                      >
                                                                                                            تایید مالی
                                                                                                      </Button>
                                                                                                }
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                              )
                                                                        })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                            component="div"
                                                            count={arrCount}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>

                                          {this.state.openImageBox && (
                                                <Lightbox
                                                      medium={urlToLargeImageFile}
                                                      large={urlToHugeImageFile}
                                                      alt={descImageFile}
                                                      onClose={this.closeLightbox}
                                                      showRotate={true}
                                                      hideZoom={false}
                                                />
                                          )}
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeRequestFinancialApprovalNot)
